// extracted by mini-css-extract-plugin
export default {"trailIndicator":"trail-indicator_trailIndicator__L4mSa"};